import styled from "styled-components";

import type { SWReactIconProps } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, rgba, setFont } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";

import { SwitcherGranularityContainer } from "app/pages/website-analysis/components/SwitcherGranularityContainer";
import { CoreWebsiteCell } from "pro-features/components/core cells/src/CoreWebsiteCell/CoreWebsiteCell";
import { InnerLink, InnerLinkContainer } from "pro-features/components/core cells/src/CoreWebsiteCell/StyledComponents";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { SearchContainer, TableWrapper } from "../../conversion/conversionTableContainer/StyledComponents";

const { carbon, midnight } = colorsPalettes;

export const StyledSwitcherGranularityContainer = styled(SwitcherGranularityContainer)`
    &.gran-switch {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 5px;
        span:last-of-type {
            button {
                border-right: 1px solid ${carbon["50"]};
            }
        }
    }
`;
const CompareButtonContainer = styled.div`
    margin-left: 10px;
`;

export const AddToDashboardWrapper = styled.div`
    margin-left: 12px;
    margin-bottom: 5px;
`;

const PageContainer = styled(FlexRow)`
    font-family: Roboto;
    padding: 32px;
    justify-content: center;
    @media (max-width: 1440px) and (min-width: 1024px) {
        padding: 8px;
    }
`;

const SegmentsAnalysisContainer = styled(FlexRow)`
    max-width: 1488px;
    display: block;
    flex-basis: 100%;
    @media (max-width: 1480px) and (min-width: 1024px) {
        max-width: calc(100% - 50px);
    }
    @media (max-width: 1024px) {
        max-width: 100%;
    }
    @media (max-width: 1566px) {
        padding: 32px 16px 16px 0;
    }
`;
SegmentsAnalysisContainer.displayName = "SegmentsAnalysisContainer";

const PageTitle = styled.div`
    font-size: 24px;
    color: ${carbon["500"]};
    margin-right: 10px;
`;
PageTitle.displayName = "PageTitle";

const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;
TitleContainer.displayName = "TitleContainer";

const CenteredRow = styled(FlexRow)`
    align-items: center;
`;
CenteredRow.displayName = "CenteredRow";

export const StyledTableWrapper = styled(TableWrapper)`
    max-width: none;
    border-radius: 6px;

    .segments-table-row-disabled-active {
        opacity: 0.5;
        &:active {
            pointer-events: none;
        }
    }

    .segments-table-row-disabled {
        opacity: 0.5;
        pointer-events: none;
    }

    .ant-table-tbody .segments-table-hover-actions-inline {
        display: flex;
        align-items: center;
        gap: 4px;
        opacity: 0;
        pointer-events: none;
        transition: opacity 120ms ease-in-out;
    }

    .ant-table-tbody .ant-table-row:hover .segments-table-hover-actions-inline {
        opacity: 1;
        pointer-events: auto;
    }

    .ant-table-cell:has(.py-0) {
        padding-top: 0;
        padding-bottom: 0;
    }
`;

export const NoDataContainer = styled.div`
    padding: 20px;
`;
const AnalyzeButton = styled(Button).attrs((props) => ({
    type: "flat",
}))`
    margin-top: -8px;
`;
AnalyzeButton.displayName = "AnalyzeButton";

export const StyledSearchContainer = styled(SearchContainer)`
    border: none;
    border-bottom: 1px solid ${carbon[100]};
    .SearchInput-container {
        margin: 0;
        div {
            top: 14px;
        }
    }
    .SearchInput-container .SearchInput {
        height: 48px;
    }
`;

export const StyledCoreWebsiteCell = styled(CoreWebsiteCell)`
    ${InnerLinkContainer} {
        width: auto;
    }
    ${InnerLink} {
        width: auto;
        &:hover {
            width: auto;
        }
    }
`;

export const EmptyStateContainer = styled.div`
    padding-top: 72px;
    padding-bottom: 72px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const EmptyStateIcon = styled(SWReactIcons).attrs<Partial<SWReactIconProps>>((props) => ({
    iconName: "no-data-lab",
}))<Omit<SWReactIconProps, "iconName">>`
    svg {
        width: 220px;
        height: 136px;
    }
`;

export const EmptyStateTitle = styled.div`
    ${setFont({ $size: "16px", $color: carbon[500], $weight: 500 })};
    text-align: center;
    margin: 28px 0 4px 0;
    max-width: 440px;
`;

export const EmptyStateSubTitle = styled.div`
    ${setFont({ $size: "14px", $color: rgba(midnight[500], 0.6) })};
    text-align: center;
    margin: 4px 0 28px 0;
    max-width: 360px;
`;

export const EmptyStateActionButtons = styled(FlexRow)`
    & > button {
        margin: 4px;
    }
`;

export const NotificationBannerContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 24px;
    margin-bottom: 0px;
    .mw-segment-data-notification-banner {
        max-width: 1320px;
        width: calc(100% - 134px);
    }
`;

export const DownloadExcelContainer = styled.a`
    margin: 0 8px 0 16px;
`;
